
export default function UserInfo() {
  const auth = sessionStorage.getItem(`oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`);
  let authParse;
  if(auth){
    authParse = JSON.parse(auth);
  }
  let userInfo = {};
  if (authParse && authParse.profile) {
    userInfo.email = authParse.profile.email
  }

  return userInfo;
};